import {
    isAndroid,
    isIOS,
    isIOS13,
    isMobile,
} from 'react-device-detect';

export const isMobileDevice = () => {
    return isAndroid || isIOS || isIOS13 || isMobile;
};